export default __webpack_public_path__ + "static/contact_pics-dcd538e24a9646cf14990a761843f383.png";